// extracted by mini-css-extract-plugin
export default {"button":"button_button__KWi7I","primary":"button_primary__NQw5-","secondary":"button_secondary__bc58g","outline":"button_outline__EcYH-","disabled":"button_disabled__-Lom4"};